// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from "@sentry/nextjs";

if (process.env.NODE_ENV !== "development") {
  Sentry.init({
    dsn: "https://1366801f9827f2aba6e3e3a377942f4c@o4506772848967680.ingest.sentry.io/4506772855324672",

    // Sample rate for transactions. Increase when investigating performance.  Use tracesSampler for greater control
    // tracesSampleRate: 0.2, turned off for now

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,

    replaysOnErrorSampleRate: 1.0,

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,

    // You can remove this option if you're not planning to use the Sentry Session Replay feature:
    integrations: [
      Sentry.replayIntegration({
        // Additional Replay configuration goes in here, for example:
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],

    ignoreErrors: [
      "ResizeObserver loop completed with undelivered notifications.",
    ],
  });
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
